/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Additional,
  ApplicationScope,
  Product,
  ProductImageDetails,
} from '../models';
import {
    AdditionalFromJSON,
    AdditionalToJSON,
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    ProductFromJSON,
    ProductToJSON,
    ProductImageDetailsFromJSON,
    ProductImageDetailsToJSON,
} from '../models';

export interface CreateProductRequest {
    xApplicationScope: ApplicationScope;
    product: Product;
}

export interface CreateProductImageRequest {
    xApplicationScope: ApplicationScope;
    body: Blob;
}

export interface CreateProductImageDetailsRequest {
    xApplicationScope: ApplicationScope;
    productImageDetails: ProductImageDetails;
}

export interface DecreaseOrderAdditionalRequest {
    xApplicationScope: ApplicationScope;
    parentProductId: string;
    additional: Additional;
}

export interface DecreaseOrderProductRequest {
    xApplicationScope: ApplicationScope;
    product: Product;
}

export interface DeleteAdditionalRequest {
    xApplicationScope: ApplicationScope;
    product: Product;
}

export interface DeleteProductRequest {
    xApplicationScope: ApplicationScope;
    product: Product;
}

export interface DeleteProductImageByIdRequest {
    id: string;
    xApplicationScope: ApplicationScope;
}

export interface GetAllProductImageDetailsByTenantRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetProductImageByIdRequest {
    id: string;
}

export interface GetProductsRequest {
    xApplicationScope: ApplicationScope;
}

export interface GetProductsForSuperadminRequest {
    xApplicationScope: ApplicationScope;
}

export interface IncreaseOrderAdditionalRequest {
    xApplicationScope: ApplicationScope;
    parentProductId: string;
    additional: Additional;
}

export interface IncreaseOrderProductRequest {
    xApplicationScope: ApplicationScope;
    product: Product;
}

export interface UpdateProductRequest {
    xApplicationScope: ApplicationScope;
    product: Product;
}

export interface UpdateProductImageByIdRequest {
    id: string;
    xApplicationScope: ApplicationScope;
    body: Blob;
}

export interface UpdateProductImageDetailsRequest {
    xApplicationScope: ApplicationScope;
    productImageDetails: ProductImageDetails;
}

/**
 * 
 */
export class ProductControllerApi extends runtime.BaseAPI {

    /**
     * create a product
     * create a product
     */
    async createProductRaw(requestParameters: CreateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Product>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createProduct.');
        }

        if (requestParameters.product === null || requestParameters.product === undefined) {
            throw new runtime.RequiredError('product','Required parameter requestParameters.product was null or undefined when calling createProduct.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductToJSON(requestParameters.product),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductFromJSON(jsonValue));
    }

    /**
     * create a product
     * create a product
     */
    async createProduct(requestParameters: CreateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Product> {
        const response = await this.createProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create product image
     * create product image
     */
    async createProductImageRaw(requestParameters: CreateProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductImageDetails>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createProductImage.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling createProductImage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'image/jpeg';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/image`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductImageDetailsFromJSON(jsonValue));
    }

    /**
     * create product image
     * create product image
     */
    async createProductImage(requestParameters: CreateProductImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductImageDetails> {
        const response = await this.createProductImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * create product image details
     * create product image details
     */
    async createProductImageDetailsRaw(requestParameters: CreateProductImageDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductImageDetails>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling createProductImageDetails.');
        }

        if (requestParameters.productImageDetails === null || requestParameters.productImageDetails === undefined) {
            throw new runtime.RequiredError('productImageDetails','Required parameter requestParameters.productImageDetails was null or undefined when calling createProductImageDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/image/details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductImageDetailsToJSON(requestParameters.productImageDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductImageDetailsFromJSON));
    }

    /**
     * create product image details
     * create product image details
     */
    async createProductImageDetails(requestParameters: CreateProductImageDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductImageDetails>> {
        const response = await this.createProductImageDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * decrease the order of the additional
     * decrease the order of the additional
     */
    async decreaseOrderAdditionalRaw(requestParameters: DecreaseOrderAdditionalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling decreaseOrderAdditional.');
        }

        if (requestParameters.parentProductId === null || requestParameters.parentProductId === undefined) {
            throw new runtime.RequiredError('parentProductId','Required parameter requestParameters.parentProductId was null or undefined when calling decreaseOrderAdditional.');
        }

        if (requestParameters.additional === null || requestParameters.additional === undefined) {
            throw new runtime.RequiredError('additional','Required parameter requestParameters.additional was null or undefined when calling decreaseOrderAdditional.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/additional/{parentProductId}/order-down`.replace(`{${"parentProductId"}}`, encodeURIComponent(String(requestParameters.parentProductId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalToJSON(requestParameters.additional),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * decrease the order of the additional
     * decrease the order of the additional
     */
    async decreaseOrderAdditional(requestParameters: DecreaseOrderAdditionalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.decreaseOrderAdditionalRaw(requestParameters, initOverrides);
    }

    /**
     * decrease the order of the product
     * decrease the order of the product
     */
    async decreaseOrderProductRaw(requestParameters: DecreaseOrderProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling decreaseOrderProduct.');
        }

        if (requestParameters.product === null || requestParameters.product === undefined) {
            throw new runtime.RequiredError('product','Required parameter requestParameters.product was null or undefined when calling decreaseOrderProduct.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/order-down`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProductToJSON(requestParameters.product),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * decrease the order of the product
     * decrease the order of the product
     */
    async decreaseOrderProduct(requestParameters: DecreaseOrderProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.decreaseOrderProductRaw(requestParameters, initOverrides);
    }

    /**
     * delete an additional
     * delete an additional
     */
    async deleteAdditionalRaw(requestParameters: DeleteAdditionalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Product>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteAdditional.');
        }

        if (requestParameters.product === null || requestParameters.product === undefined) {
            throw new runtime.RequiredError('product','Required parameter requestParameters.product was null or undefined when calling deleteAdditional.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/additional`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ProductToJSON(requestParameters.product),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductFromJSON(jsonValue));
    }

    /**
     * delete an additional
     * delete an additional
     */
    async deleteAdditional(requestParameters: DeleteAdditionalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Product> {
        const response = await this.deleteAdditionalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * delete a product
     * delete a product
     */
    async deleteProductRaw(requestParameters: DeleteProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteProduct.');
        }

        if (requestParameters.product === null || requestParameters.product === undefined) {
            throw new runtime.RequiredError('product','Required parameter requestParameters.product was null or undefined when calling deleteProduct.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ProductToJSON(requestParameters.product),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * delete a product
     * delete a product
     */
    async deleteProduct(requestParameters: DeleteProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteProductRaw(requestParameters, initOverrides);
    }

    /**
     * delete product image by id
     * delete product image by id
     */
    async deleteProductImageByIdRaw(requestParameters: DeleteProductImageByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductImageDetails>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteProductImageById.');
        }

        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling deleteProductImageById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/image/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductImageDetailsFromJSON));
    }

    /**
     * delete product image by id
     * delete product image by id
     */
    async deleteProductImageById(requestParameters: DeleteProductImageByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductImageDetails>> {
        const response = await this.deleteProductImageByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get product image details by tenant
     * get product image details by tenant
     */
    async getAllProductImageDetailsByTenantRaw(requestParameters: GetAllProductImageDetailsByTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductImageDetails>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getAllProductImageDetailsByTenant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/products/image/details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductImageDetailsFromJSON));
    }

    /**
     * get product image details by tenant
     * get product image details by tenant
     */
    async getAllProductImageDetailsByTenant(requestParameters: GetAllProductImageDetailsByTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductImageDetails>> {
        const response = await this.getAllProductImageDetailsByTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get product image by id
     * get product image by id
     */
    async getProductImageByIdRaw(requestParameters: GetProductImageByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProductImageById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/image/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * get product image by id
     * get product image by id
     */
    async getProductImageById(requestParameters: GetProductImageByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getProductImageByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all products
     * get all products
     */
    async getProductsRaw(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Product>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getProducts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductFromJSON));
    }

    /**
     * get all products
     * get all products
     */
    async getProducts(requestParameters: GetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Product>> {
        const response = await this.getProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all products
     * get all products
     */
    async getProductsForSuperadminRaw(requestParameters: GetProductsForSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Product>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getProductsForSuperadmin.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/products/super-admin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductFromJSON));
    }

    /**
     * get all products
     * get all products
     */
    async getProductsForSuperadmin(requestParameters: GetProductsForSuperadminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Product>> {
        const response = await this.getProductsForSuperadminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * increase the order of the additional
     * increase the order of the additional
     */
    async increaseOrderAdditionalRaw(requestParameters: IncreaseOrderAdditionalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling increaseOrderAdditional.');
        }

        if (requestParameters.parentProductId === null || requestParameters.parentProductId === undefined) {
            throw new runtime.RequiredError('parentProductId','Required parameter requestParameters.parentProductId was null or undefined when calling increaseOrderAdditional.');
        }

        if (requestParameters.additional === null || requestParameters.additional === undefined) {
            throw new runtime.RequiredError('additional','Required parameter requestParameters.additional was null or undefined when calling increaseOrderAdditional.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/additional/{parentProductId}/order-up`.replace(`{${"parentProductId"}}`, encodeURIComponent(String(requestParameters.parentProductId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AdditionalToJSON(requestParameters.additional),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * increase the order of the additional
     * increase the order of the additional
     */
    async increaseOrderAdditional(requestParameters: IncreaseOrderAdditionalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.increaseOrderAdditionalRaw(requestParameters, initOverrides);
    }

    /**
     * increase the order of the product
     * increase the order of the product
     */
    async increaseOrderProductRaw(requestParameters: IncreaseOrderProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling increaseOrderProduct.');
        }

        if (requestParameters.product === null || requestParameters.product === undefined) {
            throw new runtime.RequiredError('product','Required parameter requestParameters.product was null or undefined when calling increaseOrderProduct.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/order-up`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProductToJSON(requestParameters.product),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * increase the order of the product
     * increase the order of the product
     */
    async increaseOrderProduct(requestParameters: IncreaseOrderProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.increaseOrderProductRaw(requestParameters, initOverrides);
    }

    /**
     * update a product
     * update a product
     */
    async updateProductRaw(requestParameters: UpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Product>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateProduct.');
        }

        if (requestParameters.product === null || requestParameters.product === undefined) {
            throw new runtime.RequiredError('product','Required parameter requestParameters.product was null or undefined when calling updateProduct.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProductToJSON(requestParameters.product),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductFromJSON(jsonValue));
    }

    /**
     * update a product
     * update a product
     */
    async updateProduct(requestParameters: UpdateProductRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Product> {
        const response = await this.updateProductRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update product image by id
     * update product image by id
     */
    async updateProductImageByIdRaw(requestParameters: UpdateProductImageByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductImageDetails>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateProductImageById.');
        }

        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateProductImageById.');
        }

        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body','Required parameter requestParameters.body was null or undefined when calling updateProductImageById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'image/jpeg';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/image/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductImageDetailsFromJSON));
    }

    /**
     * update product image by id
     * update product image by id
     */
    async updateProductImageById(requestParameters: UpdateProductImageByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductImageDetails>> {
        const response = await this.updateProductImageByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * update product image details
     * update product image details
     */
    async updateProductImageDetailsRaw(requestParameters: UpdateProductImageDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductImageDetails>>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling updateProductImageDetails.');
        }

        if (requestParameters.productImageDetails === null || requestParameters.productImageDetails === undefined) {
            throw new runtime.RequiredError('productImageDetails','Required parameter requestParameters.productImageDetails was null or undefined when calling updateProductImageDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/products/image/details`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ProductImageDetailsToJSON(requestParameters.productImageDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProductImageDetailsFromJSON));
    }

    /**
     * update product image details
     * update product image details
     */
    async updateProductImageDetails(requestParameters: UpdateProductImageDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductImageDetails>> {
        const response = await this.updateProductImageDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
